/**
 * Spanish (es) mappings for DesktopNavigation
 */

export const desktopNavigationES = {
  // Brand name (keep as is)
  "PickStar": "PickStar",

  // Navigation items
  "Home": "Inicio",
  "Chat": "Conversar",
  "AI Exchange": "Intercambio IA",
  "Sports Hub": "Centro Deportivo",
  "Upgrade": "Actualizar",
  "Settings": "Configuración",
  "Chat Archive": "Archivo de Conversaciones",
  "About Us": "Acerca de Nosotros",
  "Help": "Ayuda",
  "Sign Out": "Cerrar Sesión",
  "Hide Sidebar": "Ocultar Barra Lateral",
};
